/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Button,
  Typography,
  Link,
  Checkbox,
  Divider,
  Box,
  useTheme,
} from "@mui/material";
import TextfieldNumber from "../components/TextfieldNumber";
import TitleDescriptionCoupon from "../components/TitleDescriptionCoupon";
// import { ReactComponent as CouponIcon } from "./../../../assets/images/coupon_icon.svg";
import { ReactComponent as EditBoxIcon } from "./../../../assets/images/edit_box_icon.svg";
import benefitsIcon from "./../../../assets/images/benefits_icon.svg";
// import BenefitsList from "../components/BenefitsList";
import TableComponent from "../components/TableComponent";
import calculateRestaurantVenuePayment from "../../../utils/calculateRestaurantVenuePayment";
import costStructure from "../../../constants/costStructure";
import whatsapp_icon from "./../../../assets/images/whatsapp_icon.svg";
import CouponTextfield from "../components/CouponTextfield";
// import Questions from "../components/Questions";
import calculateKidsPayment from "../../../utils/calculateKidsPayment";
import calculateVenuePayment from "../../../utils/calculateVenuePayment";
import { BenefitItem } from "../components/BenefitsList";
import TryFree from "../try-free";
import ImportantNote from "../important-note";
import tickRedIcon from "./../../../assets/images/tick_red_icon.svg";

const BenefitsList = ({ additionalCharges = [], isKids = false, others }) => {
  return (
    <Box sx={{ mb: 2 }}>
      {/* Restaurant + Kids */}
      {/* <BenefitItem text="Free three-month trial" /> */}
      <BenefitItem text="Unlimited venue listings on multi-venue plan" />
      <BenefitItem text="Assign Multiple venue managers for each venue" />
      <BenefitItem
        text="Detailed profile and landing page on"
        highlight=" Findmyvenue.com"
      />
      <BenefitItem text="Direct website enquiries" />
      <BenefitItem text="No booking fees or commissions on the platform" />
      <BenefitItem text="Direct access to potential clients" />
      <BenefitItem text="Detailed reporting and analytics" />
      <BenefitItem text="1 x social media post coverage" />
      {/* <BenefitItem text="Digital guided onboarding" /> */}

      {/* <Divider sx={{ borderStyle: "dashed", mb: 2, mt: 2 }} /> */}
      {/* 
			{!isKids && !others && (
				<Box sx={{ display: "flex", alignItems: "center", pl: 2 }}>
					<Typography variant="body1" sx={{ fontWeight: "600", mb: 2 }}>
						Additional Charges
					</Typography>
				</Box>
			)}

			{additionalCharges.map((charge, index) => (
				<BenefitItem
					key={index}
					text={charge.text}
					highlight={charge.highlight}
					isHighlightFirst={true}
				/>
			))} */}
    </Box>
  );
};

function createData(plan, rate, quantity, total) {
  return { plan, rate, quantity, total };
}

function createThirdTableData(description, action) {
  return { description, action };
}

const firstTableHeaders = [
  { label: "Plan Breakdown", key: "plan", align: "left" },
  { label: "Rate", key: "rate", align: "right" },
  {
    label: "Quantity",
    key: "quantity",
    align: "right",
    width: "15%",
  },
  { label: "Total", key: "total", align: "right" },
];

const secondTableHeaders = [
  { label: "", key: "plan", align: "left" },
  { label: "", key: "rate", align: "right" },
  {
    label: "",
    key: "quantity",
    align: "right",
    width: "15%",
  },
  { label: "", key: "total", align: "right" },
];

const thirdTableHeaders = [
  { label: "Description", key: "description", align: "left" },
  { label: "Action", key: "action", align: "right" },
];

function PaymentRestaurantVenueView({
  paymentData,
  handleContinue,
  sameLocation,
  items,
  setItems,
  kidsVenueView,
  user,
}) {
  const theme = useTheme();
  const [editMode, setEditMode] = useState(false);
  const [withAlcoholNumber, setWithAlcoholNumber] = useState(0);
  const [withoutAlcoholNumber, setWithoutAlcoholNumber] = useState(0);
  const [quantityNumber, setQuantityNumber] = useState(1);
  const [isChecked, setIsChecked] = useState(false);
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };
  const [calculatedValues, setCalculatedValues] = useState({
    subTotal: 0,
    grandTotal: 0,
    withAlcoholCost: 0,
    withoutAlcoholCost: 0,
    withAlcoholSaving: 0,
    withoutAlcoholSaving: 0,
    withAlcoholRate: 0,
    withoutAlcoholRate: 0,
    vat: 0,
  });
  const [discount, setDiscount] = useState(0);

  useEffect(() => {
    if (paymentData) {
      setQuantityNumber(paymentData.quantityNumber);
      setWithAlcoholNumber(paymentData.withAlcoholNumber);
      setWithoutAlcoholNumber(paymentData.withoutAlcoholNumber);
    }
    if (paymentData?.grandTotal) {
      localStorage.setItem(
        "singlechoosed",
        paymentData?.grandTotal?.toString()
      );
    }
  }, [paymentData]);
  useEffect(() => {
    // Calculate payments for restaurant and kids venue
    const restaurantPayment = calculateRestaurantVenuePayment(
      withAlcoholNumber,
      withoutAlcoholNumber,
      sameLocation,
      items
    );

    const kidsPayment = kidsVenueView
      ? calculateKidsPayment(quantityNumber, sameLocation, items)
      : calculateVenuePayment(quantityNumber, sameLocation, items);

    // Combine payments
    const combinedPayment = {
      ...restaurantPayment,
      grandTotal: restaurantPayment.grandTotal + kidsPayment.grandTotal,
      subTotal: restaurantPayment.subTotal + kidsPayment.subTotal,
      vat: restaurantPayment.vat + kidsPayment.vat,
    };

    // Calculate the discount amount
    const discountAmount = (discount / 100) * combinedPayment.subTotal;

    // Apply the discount to the subtotal
    const discountedSubtotal = combinedPayment.subTotal - discountAmount;

    // Update the grand total based on discounted subtotal and VAT
    const vatServiceFee = (discountedSubtotal * costStructure.vat) / 100;
    const grandTotal = discountedSubtotal + vatServiceFee;

    // Update combined payment with the new values
    const updatedCombinedPayment = {
      ...combinedPayment,
      subTotal: discountedSubtotal,
      grandTotal: grandTotal,
      discountAmount: discountAmount, // Optionally store the discount amount
    };

    // Store grandTotal in local storage
    localStorage.setItem("restaurantandvenuecombined", grandTotal.toString());

    // Update state with the new combined payment values
    setCalculatedValues(updatedCombinedPayment);
  }, [
    withAlcoholNumber,
    withoutAlcoholNumber,
    sameLocation,
    items,
    kidsVenueView,
    quantityNumber,
    discount,
    costStructure.vat,
  ]);

  const handleWithAlcoholNumberChange = (event) => {
    setWithAlcoholNumber(Number(event.target.value));
  };

  const handleWithoutAlcoholNumberChange = (event) => {
    setWithoutAlcoholNumber(Number(event.target.value));
  };

  const [displayedItems, setDisplayedItems] = useState([]);

  useEffect(() => {
    if (items && items.length > 0 && kidsVenueView) {
      const newItems = [];

      items.forEach((item) => {
        // Check if an item with the same 'answer' already exists in newItems
        const existingItemIndex = newItems.findIndex(
          (newItem) => newItem.answer === item.answer
        );

        if (existingItemIndex !== -1) {
          // If it exists, increase the 'amount'
          newItems[existingItemIndex].amount += 1;
        } else {
          // Add the new item (either 'yes' or 'no')
          newItems.push({ answer: item.answer, amount: 1 });
        }
      });
      // Update items with new structure
      setDisplayedItems(newItems);
    }
  }, [items]);

  const handleQuantityNumberChange = (answer, event) => {
    const newQuantityNumber = Number(event.target.value);

    let updatedItems = [...items];

    const count = displayedItems.find((i) => i.answer === answer).amount;

    // If the new quantity is greater than the current length, add items
    if (newQuantityNumber > count) {
      const itemsToAdd = newQuantityNumber - count;
      for (let i = 0; i < itemsToAdd; i++) {
        answer === "yes"
          ? updatedItems.push({ amount: 1, answer: "yes" })
          : updatedItems.push({ amount: 1, answer: "no" }); // Push new default item
      }
    }
    // If the new quantity is less than the current length, remove items from the end
    else if (newQuantityNumber < count) {
      let itemsToRemove = count - newQuantityNumber;
      updatedItems = updatedItems.filter((item) => {
        if (itemsToRemove > 0 && item.answer === answer) {
          itemsToRemove--;
          return false; // Skip these items
        }
        return true; // Keep the remaining items
      });
    }

    setItems(updatedItems);
  };

  const handleQuantityNumberChang2 = (index, event) => {
    const newQuantityNumber = Number(event.target.value);

    const updatedItems = items.map((item, idx) => {
      if (idx === index) {
        // let newAnswer = "no";
        let amount = newQuantityNumber;

        if (newQuantityNumber === 0) {
          // Set amount to 0 and answer to 'no'
          amount = 0;
          // newAnswer = "no";
        } else if (newQuantityNumber === 1) {
          // For amount 1, set answer to 'no'
          // newAnswer = "no";
        } else {
          // For amounts greater than 1, set answer to 'yes'
          // newAnswer = "yes";
        }

        return {
          ...item,
          amount,
          // answer: newAnswer,
        };
      }
      return item;
    });

    setItems(updatedItems);
  };

  const firstTableRows = paymentData
    ? [
        ...items.map((item, index) => {
          let cost = 0;
          if (item.amount === 1) {
            cost = item.answer === "no" ? 1000 : 2000;
          } else if (item.amount > 1) {
            cost = 2000;
          }
          return createData(
            <Typography sx={{ fontSize: { xs: "0.8rem" } }}>
              Unique Location {index + 1} -{" "}
              {item.answer === "no" ? "Single" : "Multi"}
            </Typography>,
            <span className="">{`$${cost}`}</span>,
            editMode ? (
              <TextfieldNumber
                min={0}
                max={1}
                value={item.amount}
                onChange={(event) => handleQuantityNumberChang2(index, event)}
              />
            ) : (
              item.amount
            ),
            `$${cost}`
            // "$0"
          );
        }),
        createData(
          <Typography sx={{ color: "#5e5e5e", fontSize: { xs: "0.8rem" } }}>
            Restaurants with alcohol{" "}
            {/* <span style={{ color: "#039F8D" }}>
              (${calculatedValues.withAlcoholSaving} saved)
            </span> */}
          </Typography>,
          <span className="">{`$${calculatedValues.withAlcoholRate}`}</span>,
          editMode ? (
            <TextfieldNumber
              value={withAlcoholNumber}
              onChange={handleWithAlcoholNumberChange}
            />
          ) : (
            withAlcoholNumber
          ),
          `$${calculatedValues.withAlcoholCost}`
          // "$0"
        ),
        createData(
          <Typography sx={{ color: "#5e5e5e", fontSize: { xs: "0.8rem" } }}>
            Restaurants without alcohol{" "}
            {/* <span style={{ color: "#039F8D" }}>
              (${calculatedValues.withoutAlcoholSaving} saved)
            </span> */}
          </Typography>,
          // `$${calculatedValues.withoutAlcoholRate}`,
          <span>{`$${calculatedValues.withoutAlcoholRate}`}</span>,
          editMode ? (
            <TextfieldNumber
              value={withoutAlcoholNumber}
              onChange={handleWithoutAlcoholNumberChange}
            />
          ) : (
            withoutAlcoholNumber
          ),
          `$${calculatedValues.withoutAlcoholCost}`
          // "$0"
        ),
      ]
    : [];

  const firstTableRowsForKids = [
    createData(
      <Typography sx={{ fontSize: { xs: "0.8rem" } }}>
        {/* Base charge (Inclusive of stay){" "} */}
        Unlimited venues included
      </Typography>,
      "Unlimited",
      "$0",
      "$0"
    ),
    createData(
      <Typography sx={{ fontSize: { xs: "0.8rem" } }}>
        {/* Unlimited Venues (Inclusive in base charge){" "} */}
        Unlimited bookings generated
      </Typography>,
      "Unlimited",
      "$0",
      "$0"
    ),
    createData(
      <Typography sx={{ fontSize: { xs: "0.8rem" } }}>
        {/* Unlimited Venues (Inclusive in base charge){" "} */}
        Promotional & marketing perks
      </Typography>,
      "Unlimited",
      "$0",
      "$0"
    ),
  ];

  const secondTableRows = [
    createData(
      <div className="flex gap-2 items-center">
        <img
          src={tickRedIcon}
          alt="Benefits Icon"
          style={{ width: "15px", height: "15px" }}
        />
        <span>Unlimited venues included</span>
      </div>,
      "",
      "",
      `$0`
    ),
    createData(
      <div className="flex gap-2 items-center">
        <img
          src={tickRedIcon}
          alt="Benefits Icon"
          style={{ width: "15px", height: "15px" }}
        />
        <span>Unlimited bookings generated</span>
      </div>,
      "",
      "",
      `$0`
    ),
    createData(
      <div className="flex gap-2 items-center">
        <img
          src={tickRedIcon}
          alt="Benefits Icon"
          style={{ width: "15px", height: "15px" }}
        />
        <span>Promotional & marketing perks</span>
      </div>,
      "",
      "",
      `$0`
    ),
  ];

  const grandTotal = calculatedValues.grandTotal;
  const thirdTableRows = paymentData
    ? [
        createThirdTableData(
          <Typography variant="h6">Grand Total</Typography>,
          <Typography>{`$${
            grandTotal ? grandTotal.toFixed(2) : "0"
          }`}</Typography>
        ),
        createThirdTableData(
          <Typography variant="h6" sx={{ fontWeight: "600" }}>
            Pay Now
          </Typography>,
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            ${grandTotal.toFixed(2)}
          </Typography>
        ),
      ]
    : [];

  const leftBox = (
    <Box
      className="overflow-hidden"
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "column" }, // Stack items vertically on mobile
        alignItems: "center",
        marginInline: { xs: "none", lg: "auto" },
        padding: { xs: 1, md: 2 },
        width: { xs: "100%", md: "100%" },
      }}
    >
      <Box
        sx={{
          width: { xs: "100%", md: "100%" },
          border: `2px solid ${theme.palette.grey.border}`,
          backgroundColor: theme.palette.white,
          borderRadius: "8px",
          display: "flex",
          flexDirection: "column",
          minHeight: "200px",
          pl: 2,
          pr: 2,
        }}
      >
        <Box
          className="justify-between items-center md:px-4 mt-3"
          sx={{
            display: "flex",
            flexDirection: { xs: "row", md: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            // px: 4,
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: "600",
              textAlign: "left",
              // py: 2,
              fontSize: { xs: "13px", md: "20px" },
            }}
          >
            Venue Plan
          </Typography>
          <Button
            variant="text"
            startIcon={<EditBoxIcon />}
            onClick={() => setEditMode(!editMode)}
            sx={{
              color: "primary.main",
              textTransform: "none",
              // m: 0,
              // mt: { xs: 0, md: 0 },
            }}
          >
            {editMode ? "Save Plan" : "Edit Plan"}
          </Button>
        </Box>

        <Divider sx={{ width: "95%", mt: 2 }} />
        <TableComponent
          headers={firstTableHeaders}
          rows={kidsVenueView ? firstTableRowsForKids : firstTableRows}
          showHeader={true}
        />

        <Divider sx={{ borderStyle: "dashed" }} />

        {/* <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            mt: 2,
            mb: 2,
          }}
        >
          {(user?.paymentStatus === undefined ||
            user?.trialStatus === "remaining" ||
            user?.paymentStatus === "Active") && (
            <CouponTextfield flag={true} />
          )}
        </Box> */}

        <Divider sx={{ borderStyle: "dashed" }} />

        <TableComponent
          headers={secondTableHeaders}
          rows={secondTableRows}
          showHeader
        />

        <Box
          sx={{
            width: "100%",
            mt: -2.8,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Divider sx={{ width: "95%", mt: 3, mb: -1 }} />
        </Box>
        <TableComponent headers={thirdTableHeaders} rows={thirdTableRows} />
      </Box>
    </Box>
  );

  const rightBox = (
    <Box
      sx={{
        width: { xs: "100%", md: "40%" },
        border: `2px solid ${theme.palette.grey.border}`,
        backgroundColor: theme.palette.white,
        borderRadius: "8px",
        display: "flex",
        flexDirection: "column",
        minHeight: "200px",
        px: 4,
      }}
    >
      {/* For Icon + Plan Benefits*/}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mt: 2,
        }}
      >
        <Box
          sx={{
            backgroundColor: theme.palette.primary.light,
            display: "flex",
            justifyContent: "center",
            borderRadius: "8px",
            mr: 2,
          }}
        >
          <img
            src={benefitsIcon}
            alt="Benefits Icon"
            style={{
              width: "40px",
              height: "40px",
            }}
          />
        </Box>
        <Typography
          variant="h5"
          color={theme.palette.primary.main}
          fontWeight={500}
          sx={{ fontSize: "1.6rem" }}
        >
          Plan Benefits
        </Typography>
      </Box>
      {/* For Base Charge*/}
      {/* <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mt: 2,
          ml: 3,
          justifyContent: "space-between",
        }}
      >
        <Typography
          variant="body1"
          color={theme.palette.grey.dark}
          fontWeight={500}
        >
           Charge: $1,500
        </Typography>
      </Box> */}
      <BenefitsList
        additionalCharges={[
          {
            text: "$1000/60 - sec video",
          },
          {
            text: "$600/professional photoshoot",
          },
          {
            text: "$300/10 branded images",
          },
          {
            text: "$400/house alcohol",
          },
          {
            text: "$500/permium alcohol",
          },
        ]}
      />
    </Box>
  );

  const bottomBox = (
    <Box
      // className="bg-red-700"
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        pl: 4,
        mt: 2,
      }}
    >
      {/* <ImportantNote /> */}
      {/* TERMS AND CONDITIONS */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mt: 2,
          flexDirection: { xs: "rows", md: "row" },
        }}
      >
        <Checkbox
          color="primary"
          checked={isChecked}
          onChange={handleCheckboxChange}
          required
        />
        <Box sx={{ textAlign: "left" }}>
          <Typography
            sx={{ fontSize: { xs: "12px", lg: "14px" } }}
            style={{ color: theme.palette.grey.text }}
          >
            {"I agree to all "}
            <Link href="/terms&conditions" target="_blank">
              <span
                className="tracking-[1px] cursor-pointer"
                style={{
                  color: theme.palette.primary.main,
                  fontWeight: "400",
                }}
              >
                Terms & Conditions
              </span>
            </Link>
            {" and "}
            <Link href="/cancellation-policy" target="_blank">
              <span
                className="tracking-[1px]"
                style={{
                  color: theme.palette.primary.main,
                  fontWeight: "400",
                }}
              >
                Cancellation policy
              </span>
            </Link>
            {" including usage of cookies"}
          </Typography>
        </Box>
      </Box>
      {/* <ImportantNote /> */}

      <Button
        type="submit"
        variant="contained"
        size="large"
        onClick={handleContinue}
        disabled={
          !isChecked ||
          (withAlcoholNumber === 0 &&
            withoutAlcoholNumber === 0 &&
            items.length === 0)
        }
        sx={{
          mb: { xs: 1, md: 3 },
          borderRadius: "8px",
          width: { xs: "80%", lg: "400px" },
          margin: "auto",
          mt: 2,
          backgroundColor: isChecked
            ? theme.palette.primary.main
            : theme.palette.grey.border,
          textTransform: "none",
        }}
      >
        {user?.paymentStatus == "Cancelled" ? (
          <>Start Your Plan</>
        ) : (
          <>Continue</>
        )}
      </Button>

      {/* Whatsapp related Text */}
      <Box
        sx={{
          display: "flex",
          gap: 1,
          fontSize: { xs: "12px", md: "14px" },
          letterSpacing: "0.5px",
          textAlign: { xs: "center", md: "left" },
        }}
      >
        <img
          src={whatsapp_icon}
          alt="Whatsapp"
          style={{ height: 22, width: 22, pl: "5px" }}
        />
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.grey.text,
            fontWeight: "500",
          }}
        >
          <span>For any queries </span>
          <Link target="_blank" href="/contact" sx={{ textDecoration: "none" }}>
            <span
              style={{
                textTransform: "none",
                fontWeight: "700",
                color: theme.palette.primary.main,
              }}
            >
              contact us
            </span>
          </Link>
          <span> here—we’re here to help!</span>
        </Typography>
      </Box>
    </Box>
  );

  return (
    <Box
      className="w-full"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.palette.white,
        borderRadius: theme.shape.borderRadius,
        width: { xs: "100%", sm: "80%", md: "100%" },
        pl: 2,
      }}
    >
      <TitleDescriptionCoupon
        title={"Take a look at our plan suitable for your needs! "}
        description={"We found this plan to be best suited for your needs"}
      />
      <Box
        sx={{
          width: "100%",
          heigth: "100%",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "center", md: "flex-start" },
          ml: 2,
        }}
      >
        {/* <Box sx={{ pl: 3, pr: 2, width: "100%", border: "none", boxShadow: 0 }}>
          <TryFree />
        </Box> */}
      </Box>
      <Box
        // className="bg-red-700"
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          // alignItems: { xs: "center", md: "flex-start" },
          alignItems: "stretch",
          mt: 1,
          pl: 2,
          flexGrow: 1,
        }}
      >
        {leftBox}
        {rightBox}
      </Box>
      {bottomBox}
    </Box>
  );
}

export default PaymentRestaurantVenueView;
